
const PostIcon = () => (
  <img src={require('../../assets/img/icons/asada-icon.png')} alt='Asada' style={{ width: '100%'}} />
);

export default PostIcon;